<template>
  <div class="zdgllbcz">
    <div class="headergl">
      <div class="headerglinside">
        <el-form
          ref="searchForm"
          :model="searchForm"
          class="demo-form-inline"
          style="display: flex; height: 39px"
          label-width="0px"
          label-position="left"
        >
          <el-form-item label="" prop="dictLabel">
            <el-input
              v-model="searchForm.dictLabel"
              placeholder="字典标签"
              clearable
            />
          </el-form-item>
          <el-form-item prop="status">
            <el-select
              v-model="searchForm.status"
              style="min-width: 140px"
              placeholder="状态"
              clearable
            >
              <el-option
                v-for="item in [
                  { value: 0, label: '正常' },
                  { value: 1, label: '停用' },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button
              type="primary"
              style="
                background: #50b293;
                border-radius: 20px;
                border-color: #50b293;
              "
              icon="el-icon-search"
              @click="search"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh-left"
              round
              @click="reset"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tableGMZ">
      <div class="tableinside">
        <div class="addmessheader">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="addmess"
            size="mini"
            style="background: #4285c7; border-color: #4285c7; color: #fff"
            @click="addMes"
          >新增</el-button>
          <!-- <el-button
            icon="el-icon-edit-outline"
            class="addmessedit"
            size="mini"
            style="background: #87d8c3; border-color: #87d8c3; color: #fff"
            >修改</el-button
          >
          <el-button
            icon="el-icon-close"
            size="mini"
            class="addmessedit"
            style="background: #e99ea6; border-color: #e99ea6; color: #fff"
            >删除</el-button
          > -->
          <el-button
            icon="el-icon-back"
            size="mini"
            style="background: #dd5766; border-color: #dd5766; color: #fff"
            @click="back"
          >关闭</el-button>
        </div>

        <el-table
          ref="zdgllbTable"
          :data="tableData"
          style="width: 100%"
          border
          :show-overflow-tooltip="true"
        >
          <el-table-column
            label="字典编码"
            align="center"
            prop="dictCode"
          />
          <el-table-column
            label="字典标签"
            align="center"
            prop="dictLabel"
          />
          <el-table-column label="字典键值" align="center" prop="dictValue" />
          <el-table-column
            label="字典类型"
            align="center"
            prop="dictType"
          />
          <el-table-column
            label="字典排序"
            align="center"
            prop="dictSort"
          />
          <el-table-column label="是否默认" align="center" prop="isDefault">
            <template slot-scope="scope">{{
              scope.row.isDefault ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === '0' ? 'success' : 'warning'"
                disable-transitions
              >{{ scope.row.statusStr }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            show-overflow-tooltip
            align="left"
            prop="remark"
          />

          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button
                v-preventReClick
                type="primary"
                icon="el-icon-edit-outline"
                size="mini"
                style="background: #4183c6; border-color: #4183c6; color: #fff"
                @click="handleEdit(scope.row)"
              >编辑</el-button>

              <el-button
                v-preventReClick
                size="mini"
                icon="el-icon-close"
                style="background: #dd5766; border-color: #dd5766; color: #fff"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <!-- 字典管理列表编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="submitForm.dictCode ? '修改数据' : '新增数据'"
      :visible.sync="dialogFormVisible"
      width="500px"
      custom-class="zhengjian"
      center
      @close="cancleHandle"
    >
      <el-form ref="submitForm" :model="submitForm">
        <el-form-item label-width="91px" label="字典标签:" prop="dictLabel" :rules="[{ required: true, message: '请输入字典标签' }]">
          <el-input
            v-model="submitForm.dictLabel"
            placeholder="请输入"
            maxlength="200"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="字典键值:" prop="dictValue" :rules="[{ required: true, message: '请输入字典键值' }]">
          <el-input
            v-model="submitForm.dictValue"
            placeholder="请输入"
            maxlength="200"
          />
        </el-form-item>
        <el-form-item
          label-width="91px"
          label="状态:"
          prop="status"
          :rules="[{ required: true, message: '请选择状态' }]"
        >
          <el-radio-group v-model="submitForm.status">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label-width="91px"
          label="是否默认:"
          prop="isDefault"
          :rules="[{ required: true, message: '请选择状态' }]"
        >
          <el-radio-group v-model="submitForm.isDefault">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label-width="91px" label="字典排序:" prop="dictSort">
          <el-input
            v-model.number="submitForm.dictSort"
            type="number"
            placeholder="请输入"
            maxlength="10"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="备注:" prop="remark">
          <el-input
            v-model="submitForm.remark"
            type="textarea"
            :rows="3"
            resize="none"
            maxlength="200"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleHandle">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          style="background: #4285c7; border-color: #4285c7; color: #fff"
          @click="submitHandle"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDictDataList, addDictData, updateDictData, deleteDictData } from '@/assets/js/dict.js'
export default {
  components: {},
  props: {
    dictType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      // 搜索条件
      searchForm: {
        dictLabel: '', //  --字典名称
        dictType: this.dictType, //  --字典类型
        status: '' // --状态（0正常 1停用）
      },
      submitForm: {
        dictCode: '', // -- 字典编码(字典数据的主键)
        dictSort: '', // --字典排序
        dictLabel: '', // --字典标签
        dictValue: '', // --字典键值
        dictType: '', //  -- 字典类型
        isDefault: '', //  -- 是否默认（Y是 N否）
        status: '', // -- 状态（0正常 1停用）
        remark: '' // -- 备注
      },
      type: false, // 添加和编辑，可编辑，查看不可编辑
      multipleSelection: [], // 多选选中数据
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      tableData: [], // 表格数据
      total: 0, // 总条数
      dialogFormVisible: false,
      detailMes: {}, // 编辑或查看每条数据的信息
      liexing: '',
      options: []
    }
  },
  watch: {
    dictType() {
      this.searchForm.dictType = this.dictType
      this.search()
    }
  },
  methods: {
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.zdgllbTable.clearSelection()
        this.$refs.zdgllbTable.toggleRowSelection(val.pop())
      }
    },
    checkSelect(selection) {
      this.$refs.zdgllbTable.clearSelection()
    },
    // 点击搜索时
    search() {
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      getDictDataList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    // 编辑
    handleEdit(row) {
      this.dialogFormVisible = true
      this.submitForm = Object.assign({}, row)
    },
    // 点击申请按钮
    addMes() {
      this.dialogFormVisible = true
      this.submitForm = {
        dictCode: '', // -- 字典编码(字典数据的主键)
        dictSort: '', // --字典排序
        dictLabel: '', // --字典标签
        dictValue: '', // --字典键值
        dictType: '', //  -- 字典类型
        isDefault: '', //  -- 是否默认（Y是 N否）
        status: '', // -- 状态（0正常 1停用）
        remark: '' // -- 备注
      }
      this.$nextTick(() => {
        this.$refs.submitForm.clearValidate()
      })
    },
    reset() {
      this.$refs['searchForm'].resetFields()
      this.search()
    },
    cancleHandle() {
      // 取消
      this.$refs.submitForm.resetFields()
      this.dialogFormVisible = false
    },
    submitHandle() {
      // 提交
      this.$refs.submitForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let API = addDictData
          if (this.submitForm.dictCode) {
            API = updateDictData
          }
          const params = Object.assign({}, this.submitForm)
          params.dictType = this.dictType
          API(params).then(res => {
            this.loading = false
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.cancleHandle()
              this.loadData()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    // 删除行数据
    handleDelete(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteDictData(row.dictCode).then((res) => {
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.loadData()
            }
          })
        })
    },
    back() {
      this.$parent.visable = true
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      //   this.search();
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;
  border: 1px solid #ebeef5;
  border-top: 0;
}
.el-tag--primary {
  border-radius: 14px;
}
.el-tag--success {
  border-radius: 14px;
  background-color: #4eb091;
  color: #fff;
}
//   .el-button--primary {
//     color: #fff;
//     background-color: #4170ff;
//     border-color: #4170ff;
//   }
.zdgllbcz {
  margin-top: 35px;

  .headergl {
    max-width: 1503px;
    width: 95%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 96px;
    background-color: #fff;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    margin-bottom: 10px;
    .headerglinside {
      margin: 0 auto;
      width: 90%;
      /deep/ .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
  }

  .tableGMZ {
    max-width: 1503px;
    background-color: #fff;
    width: 95%;
    margin: 0 auto;
    .tableinside {
      width: 90%;
      margin: 0 auto;
      padding: 40px 0 57px;
      /deep/ .el-table {
        z-index: 0;
      }
      /deep/ .el-table .has-gutter tr th {
        background: #f4f4f4;
      }
      .addmessheader {
        background: #f4f4f4;
        color: #fff;
        .addmess {
          margin: 12px 0 12px 8px;
        }
      }
    }
  }
}
</style>
